import { memo } from "react";

import { getThemeColor } from "@theme";

import type { IButtonLoaderProps } from "@atoms/loader/types";
import "ldrs/dotPulse";

export const ButtonLoader = memo(function ButtonLoader({
  size,
  color,
}: IButtonLoaderProps) {
  const themeColor = getThemeColor(color || "text-sub-600").colorValue;

  return <l-dot-pulse size={size || "43"} speed={"1"} color={themeColor} />;
});
